import React from 'react';
import { Cpu, HardDrive, Monitor, Battery, Wifi, Bluetooth } from 'lucide-react';

const ElectronicsDetails = ({ listing }) => {
  const details = listing.specialized_data || {};
  
  if (!details || details._type !== 'electronics') return null;

  const specs = [
    { icon: Cpu, label: 'Processor', value: details.processor },
    { icon: HardDrive, label: 'Storage', value: details.storage_capacity },
    { icon: Monitor, label: 'Screen Size', value: details.screen_size },
    { icon: HardDrive, label: 'RAM', value: details.ram },
    { icon: Monitor, label: 'Resolution', value: details.screen_resolution },
    { icon: Battery, label: 'Battery Health', value: details.battery_health },
    { icon: Wifi, label: 'Network Type', value: details.network_type },
    { icon: Bluetooth, label: 'Connectivity', value: details.connectivity },
  ];

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Specifications</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {specs.map((spec, index) => {
          if (!spec.value) return null;
          return (
            <div key={index} className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
              <div className="p-2 bg-white rounded-lg shadow-sm">
                <spec.icon className="w-5 h-5 text-blue-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm text-gray-500">{spec.label}</p>
                <p className="font-medium text-gray-900">{spec.value}</p>
              </div>
            </div>
          );
        })}
        
        {/* Brand & Model */}
        {(details.brand || details.model) && (
          <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
            <div className="p-2 bg-white rounded-lg shadow-sm">
              <span className="text-lg font-bold text-blue-600">ℹ️</span>
            </div>
            <div className="flex-1">
              <p className="text-sm text-gray-500">Brand & Model</p>
              <p className="font-medium text-gray-900">
                {details.brand} {details.model}
              </p>
            </div>
          </div>
        )}
        
        {/* Color */}
        {details.color && (
          <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
            <div className="p-2 bg-white rounded-lg shadow-sm">
              <div 
                className="w-5 h-5 rounded-full border" 
                style={{ backgroundColor: details.color.toLowerCase() }}
              />
            </div>
            <div className="flex-1">
              <p className="text-sm text-gray-500">Color</p>
              <p className="font-medium text-gray-900">{details.color}</p>
            </div>
          </div>
        )}
        
        {/* Operating System */}
        {details.operating_system && (
          <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
            <div className="p-2 bg-white rounded-lg shadow-sm">
              <span className="text-lg">🖥️</span>
            </div>
            <div className="flex-1">
              <p className="text-sm text-gray-500">Operating System</p>
              <p className="font-medium text-gray-900">{details.operating_system}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ElectronicsDetails;